import { createContext, useContext } from 'react';

import type { AuthApi } from '@breezeventures/web-ph-client-auth/api';

export const AuthApiContext = createContext<AuthApi | null>(null);

export const useAuthApi = (): AuthApi => {
  const api = useContext(AuthApiContext);

  if (!api) {
    throw new Error('useAuthApi must be used within AuthApiProvider');
  }

  return api;
};
